// SOPs, playbooks, and per-team operational folders.

export const OPS = {
  intro:"SOPs, playbooks, and operational trackers. If you do a task more than twice, the how-to should live here.",
  // Team name → link id. The URL itself is resolved by /api/links.
  teamFolders:{
    "Worship & Music":"ops-team-worship-and-music",
    "Production & Media":"ops-team-production-and-media",
    "Guest Experience":"ops-team-guest-experience",
    "CLLXTV Kids":"ops-team-cllxtv-kids",
    Prayer:"ops-team-prayer",
    Creative:"ops-team-creative"
  },
  breakouts:[
    {
      icon:"📖",
      name:"How-To Wiki",
      desc:"The readable versions: every procedure distilled to what you actually do, linked to its source.",
      id:"ops-how-to-wiki"
    },
    {
      icon:"📜",
      name:"Standards & SOPs",
      desc:"Step-by-step procedures for every recurring task.",
      id:"ops-standards-and-sops"
    },
    {
      icon:"✅",
      name:"Checklists",
      desc:"Run sheets teams work through on the day — Sunday setup, teardown, MDWK.",
      id:"ops-checklists"
    },
    {
      icon:"📋",
      name:"Request Forms",
      desc:"Bookings, storage retrieval, after-action reports, supplies.",
      id:"ops-request-forms"
    },
    {
      icon:"📚",
      name:"External Reference",
      desc:"Material from outside CLLXTV — reference only, not our vault.",
      id:"ops-external-reference"
    }
  ]
};
